import store from '@/store'

const TokenKey = 'X-Token-Web'

export function getToken() {
  let token = ''
  const requestParams = GetRequest()
  if (requestParams && requestParams.token) {
    token = requestParams.token
    setToken(requestParams.token)
  } else {
    token = localStorage.getItem(TokenKey)
  }
  return token
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}

export function GetRequest() {
  let url = location.search // 获取url中'?'符后的字串
  if (url.indexOf('token') == -1) {
    url = location.hash
  }
  if (url.indexOf('token') == -1) {
    url = location.href
  }
  let requestParams = new Object()
  if (url.indexOf('?') != -1) {
    let str = url.substr(url.indexOf('?') + 1)
    let strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      requestParams[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }
  return requestParams
}

const RouterKey = 'X-Router-Web'
const HistoryRouterKey = 'X-Router-Web-history'

export function setRouter(data) {
  return localStorage.setItem(RouterKey, data)
}

export function setHistoryRouter (data) {
  localStorage.setItem(HistoryRouterKey, data)
}

export function removeRouter() {
  return localStorage.removeItem(RouterKey)
}

export function getRouter() {
  let router = {}
  if (location.hash == '#/dashboard') {
    router = { href: '', menuId: -2 }
    setRouter(JSON.stringify(router))
  } else if (localStorage.getItem(RouterKey)) {
    router = JSON.parse(localStorage.getItem(RouterKey))
  } else {
    router = { href: '', menuId: -2 }
    setRouter(JSON.stringify(router))
  }
  return router
}

export function getHistoryRouter() {
  let router = {}
  if (localStorage.getItem(HistoryRouterKey)) {
    router = JSON.parse(localStorage.getItem(HistoryRouterKey))
  } else {
    router = { href: 'dashboard', menuId: -2 }
    setHistoryRouter(JSON.stringify(router))
  }
  return router
}

export function getMenuId() {
  let menuId = ''
  // debugger
  const requestParams = GetRequest()
  if (requestParams != null) {
    menuId = requestParams.menuId || requestParams.resource
  }
  return menuId
}

// export function setIframRouter(routeItem) {
//   let bpmHref = routeItem.href + '&isChildPage=1&token=' + getToken()
//   let data = { href: bpmHref, menuId: routeItem.menuId }
//   store.dispatch('setMenuId', data)
//   setRouter(JSON.stringify(data))
//   let routerData = {
//     name: 'frame',
//     href: '/frame',
//     query: { resource: routeItem.menuId }
//   }
//   return routerData
// }

export function setIframRouter(routeItem) {
  let bpmHref = routeItem.href + '&isChildPage=1&token=' + getToken()
  let data = { href: bpmHref, menuId: routeItem.menuId }
  store.dispatch('setMenuId', data)
  setRouter(JSON.stringify(data))
  let routerData = {
    name: 'frameIndex',
    href: '/frameIndex',
    query: { resource: routeItem.menuId }
  }
  if(routeItem.href.indexOf('webgui/page')>-1){
    routerData = {
      name: 'frame',
      href: '/frame',
      query: { resource: routeItem.menuId }
    }
    routerData.query.ifr = bpmHref
  }
  return routerData
}

export function setNameRouter(routeItem) {
  let name = ''
  let queryData = {}
  if (routeItem.href.indexOf('?') !== -1) {
    let arr = routeItem.href.split('?')
    name = arr[0]
    let queryStr = arr[1]
    queryStr.split('&').forEach(item => {
      let params = item.split('=')
      if (params.length === 2) {
        queryData[params[0]] = params[1]
      }
    })
  } else {
    name = routeItem.href
    queryData = {}
  }
  return {
    name: name,
    query: queryData
  }
}



// WEBPACK FOOTER //
// ./src/utils/storage.js